import React from 'react'
import { ArrowRight, CheckCircle, MessageCircle } from 'lucide-react'

export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#0891b2] via-[#06b6d4] to-[#22d3ee] relative overflow-hidden">
      {/* Floating Bubbles Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-white/20 rounded-full animate-floatRandom"
            style={{
              width: `${8 + Math.random() * 12}px`,
              height: `${8 + Math.random() * 12}px`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${5 + Math.random() * 5}s`
            }}
          />
        ))}
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Main Heading */}
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Transform Your
          <br />
          Laundry Business?
        </h2>

        {/* Subheading */}
        <p className="text-lg sm:text-xl text-white/90 mb-8 max-w-2xl mx-auto">
          Join hundreds of successful laundry shop owners who are already using LaundryMate to streamline their operations and grow their business.
        </p>

        {/* Benefits List */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-10 text-white">
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5" />
            <span>Full-featured platform</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5" />
            <span>Real-time updates</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5" />
            <span>24/7 support</span>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="https://app.laundrymate.shop"
            className="group inline-flex items-center gap-2 bg-white text-cyan-600 px-10 py-5 rounded-xl font-bold text-lg transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-110 hover:-translate-y-1 active:scale-95"
          >
            Get Started Now
            <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" />
          </a>
          <a
            href="https://m.me/946243658562372"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white px-10 py-5 rounded-xl font-bold text-lg transition-all duration-300 hover:bg-white/20 hover:scale-110 hover:-translate-y-1 active:scale-95"
          >
            <MessageCircle className="w-5 h-5" />
            Chat with Us
          </a>
        </div>

        {/* Trust Badge */}
        <div className="mt-12 text-white/80 text-sm">
          <p className="mb-3">Trusted by 50+ laundry shops across the Philippines</p>
          <div className="flex justify-center items-center gap-6 flex-wrap">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                ⭐
              </div>
              <span>4.9/5 Rating</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                🔒
              </div>
              <span>Bank-level Security</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                💬
              </div>
              <span>24/7 Support</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
